<script>
import {createDrawingTool} from './drawing-tool.js'
import {STANDARD_DRAWINGS} from '../../workspace/drawing-geometry.mjs'
export default createDrawingTool('StandardDrawingTool',function(){
 const mods={};
 STANDARD_DRAWINGS.slice(1).forEach(([name,category])=>{mods[name.replace(/ /g,'')]={name,category,icon:'rectangle.svg',settings:{kind:name,...(['Text','Note','Callout','Comment','Table','Anchored Text','Anchored Note','X Post','Idea'].includes(name)?{text:name}:{})}}});
 return {group:'Shapes',category:'Shapes',type:'StandardDrawingTool',name:'Ellipse',icon:'rectangle.svg',hint:'Click anchors; Enter finishes paths, drag for freehand',data:[],settings:{kind:'Ellipse'},mods};
})
</script>
